import { render, staticRenderFns } from "./ValidateAccount.vue?vue&type=template&id=554d07e1"
import script from "./ValidateAccount.vue?vue&type=script&lang=js"
export * from "./ValidateAccount.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports